/**
 * Categories Manager - Handles all marker categories operations outside of React lifecycle
 */

/**
 * Handles the marker categories toggle.
 * @function HandleMarkerCats
 * @returns {void}
 */
const HandleMarkerCats = () => {
  const categories = document.querySelectorAll('.js-marker-category')

  if (categories.length) {
    toggleCategory(categories)
  } else {
    return
  }
}

/**
 * Toggles the visibility of markers based on the state of category checkboxes.
 *
 * @param {NodeListOf<HTMLInputElement>} categories - A collection of checkbox elements representing categories.
 * Each checkbox should have a `value` attribute corresponding to the category slug.
 *
 */
const toggleCategory = ( categories ) => {
  categories.forEach(category => {
    category.addEventListener("change", () => {
      const categorySlug = category.value

      if (!category.checked) { // Checkbox is unchecked
        hideMarkers(categorySlug)
      } else {
        showMarkers(categorySlug)
      }
    })
  })
}

/**
 * Hides markers on the page based on a specified category slug.
 *
 *
 * @param {string} slug - The category slug used to determine which markers to hide.
 *                         Markers with this slug in their `data-marker-categories`
 *                         attribute will be hidden.
 */
const hideMarkers = ( slug ) => {
  const markers = document.querySelectorAll('.js-marker-button')

  markers.forEach(marker => {
    const markerCategories = JSON.parse(marker.dataset.markerCategories || '[]');

    if (markerCategories.length >= 0 && markerCategories.includes(slug)) {
      marker.dataset.markerState = 'hidden'
      marker.classList.add('is-hidden');
    } else {
      return
    }
  });
}

/**
 * Shows markers on the page based on a specified category slug.
 *
 *
 * @param {string} slug - The category slug used to determine which markers to hide.
 *                         Markers with this slug in their `data-marker-categories`
 *                         attribute will be hidden.
 */
export const showMarkers = ( slug ) => {
  console.log('showMarkers');

  const markers = document.querySelectorAll('.js-marker-button')

  markers.forEach(marker => {
    const markerCategories = JSON.parse(marker.dataset.markerCategories || '[]');

    if (markerCategories.length >= 0 && markerCategories.includes(slug)) {
      marker.dataset.markerState = 'hidden'
      marker.classList.remove('is-hidden');
    } else {
      return
    }
  });
}

/**
 * Unchecks a category filter checkbox and hides associated markers.
 *
 * @param {string} slug - The slug of the category to uncheck.
 */
export const uncheckCategoryFilter = ( slug ) => {
  const categoryCheckbox = document.querySelector(`.js-marker-category[value="${slug}"]`);

  // Uncheck the checkbox and hide markers.
  if (categoryCheckbox) {
    categoryCheckbox.checked = false;
    hideMarkers(slug)
  }
}

export default HandleMarkerCats;
